module.exports = __webpack_public_path__ + "img/homework-empty.25b2a95f.png";